var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root gig-status"},[_c('div',[_vm._v("Status")]),_c('GigStatusBadge',{staticClass:"badge",attrs:{"status":_vm.status,"moderationStage":_vm.moderationStage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }